import { Col, Row, Typography } from 'antd';
import { FC } from 'react';

import { CopyableText, DescriptionBlock, EmptyText, HiddenPassword } from '@/common/components';
import { BaseQueryParams } from '@/common/interfaces';
import { CommonDrawerTitle } from '@/common/layouts';
import { getDateFactory } from '@/common/utils';

import { useGetByIdSearchConsoleAccountsQuery } from '@/modules/DomainsApi';

import { SearchConsoleAccountsOverviewDropdown } from './SearchConsoleAccountsOverviewDropdown';

interface Props {
  searchConsoleAccount: BaseQueryParams<typeof useGetByIdSearchConsoleAccountsQuery>['data'];
  isDeleteSearchConsoleAccountLoading: boolean;
  isItemsDisabled: boolean;
  handleEditSearchConsoleAccount: () => void;
  handleDeleteSearchConsoleAccount: () => void;
  handleRevokeTokenOAuth2: () => void;
}

export const SearchConsoleAccountsOverviewView: FC<Props> = ({
  searchConsoleAccount,
  isDeleteSearchConsoleAccountLoading,
  isItemsDisabled,
  handleEditSearchConsoleAccount,
  handleDeleteSearchConsoleAccount,
  handleRevokeTokenOAuth2
}) => {
  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <SearchConsoleAccountsOverviewDropdown
            isDeleteSearchConsoleAccountLoading={ isDeleteSearchConsoleAccountLoading }
            isItemsDisabled={ isItemsDisabled }
            handleEditSearchConsoleAccount={ handleEditSearchConsoleAccount }
            handleRevokeTokenOAuth2={ handleRevokeTokenOAuth2 }
            handleDeleteSearchConsoleAccount={ handleDeleteSearchConsoleAccount }
          />
        }
      />

      <Row gutter={ [0, 16] }>
        <Col span={ 24 }>
          <DescriptionBlock
            items={ [[
              'Email',
              <CopyableText key="email" textToCopy={ searchConsoleAccount.email }>
                { searchConsoleAccount.email }
              </CopyableText>
            ]] }
          />

          <DescriptionBlock
            items={ [['Пароль', <HiddenPassword key="password" password={ searchConsoleAccount.password }/>]] }
          />

          <DescriptionBlock
            items={ [[
              'Додаткова адреса електронної пошти',
              searchConsoleAccount?.backupEmailAddress
                ? (
                  <CopyableText key="email" textToCopy={ searchConsoleAccount.backupEmailAddress }>
                    { searchConsoleAccount.backupEmailAddress }
                  </CopyableText>
                )
                : <EmptyText/>
            ]] }
          />


          <DescriptionBlock
            items={
              [[
                'Client ID',
                <>
                  {
                    searchConsoleAccount.clientId
                      ? <HiddenPassword password={ searchConsoleAccount.clientId }/>
                      : <EmptyText/>
                  }
                </>
              ]] }
          />
          <DescriptionBlock
            items={
              [[
                'Client secret',
                <>
                  {
                    searchConsoleAccount.clientSecret
                      ? <HiddenPassword password={ searchConsoleAccount.clientSecret }/>
                      : <EmptyText/>
                  }
                </>
              ]] }
          />
          <DescriptionBlock
            items={
              [[
                'Останнє використання токену',
                <>
                  {
                    searchConsoleAccount.refreshTokenLastUsedAt
                      ? getDateFactory(searchConsoleAccount.refreshTokenLastUsedAt, 'Thursday, August 16, 2018 08:02', true)
                      : <EmptyText/>
                  }
                </>
              ]] }
          />
          { searchConsoleAccount.refreshTokenError && (
            <DescriptionBlock
              items={ [[
                'Помилка токену',
                <Typography.Text key="refreshTokenError" type="danger">
                  { searchConsoleAccount.refreshTokenError }
                </Typography.Text>
              ]] }
            />
          ) }
        </Col>
      </Row>
    </>
  );
};
